/**
 * API endpoint paths for client profile operations.
 *
 * These are relative paths (no base URL). Each app prepends its own backend URL.
 * Trailing slashes included to match Django URL conventions.
 */
export const ClientProfileEndpoints = {
  /** GET /api/client/profile/{userId}/ — Full client profile (slim: no ocrData) */
  profile: "api/client/profile/",
  /** POST /api/client/profile/{userId}/ — Update a single field */
  updateField: "api/client/profile/",
  /** POST/DELETE /api/client/dynamic-items/{userId}/ — Add/remove dynamic items */
  dynamicItems: "api/client/dynamic-items/",
  /** GET /api/forms/data/{formId}/?extraction_id={id} — Lazy-load OCR data for an extraction */
  formData: "api/forms/data/",
  /** PATCH /api/forms/extractions/{extractionId}/toggle/ — Toggle extraction enabled state */
  extractionToggle: "api/forms/extractions/",
  /** POST /api/ocr/document/{documentId}/ — Start OCR processing for a document */
  startOCR: "api/ocr/document/",
  /** POST /api/forms/archive/{documentId}/ — Archive a document */
  archiveDocument: "api/forms/archive/",
  /** POST /api/forms/recategorize/ — Recategorize a document */
  recategorizeDocument: "api/forms/recategorize/",
} as const
